<template>
    <div id="plan-feature">
        <div class="feature">
            <div class="feature-title">Chat Feature</div>
            <div class="feature-delete" @click="$emit('close')"><span class="material-icons">close</span></div>
        </div>
        <div class="feature-form">
            <div class="feature-item">
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.autoTranslation">Auto Translation</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.voiceCalling">Voice Calling</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.videoCalling">Video Calling</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.fileAndVoiceMessage">Dosya ve Ses Kaydı Paylaşımı</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.chatCopilot">Yapay Zekalı Assistan</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.liveChat">Canlı Desktek Modülü</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.liveScore">Canlı İzleme Özelliği</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.multipleChatWindow">Çoklu Chat Penceresi</a-checkbox>
                </div>
                <div class="feature-input">
                    <a-checkbox v-model="featureForm.shareScreen">Ekran Paylaşma</a-checkbox>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { FeatureItems } from "./index";

export default {
    props: {
        value: {
            type: Object,
            default: {},
        },
        type: {
            type: String,
            default: null,
        },
    },
    data: () => ({
        form: {},
        featureForm: {
            autoTranslation: false,
            voiceCalling: false,
            videoCalling: false,
            fileAndVoiceMessage: false,
            chatCopilot: false,
            liveChat: false,
            liveScore: false,
            multipleChatWindow: false,
            shareScreen: false,
        },
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.form = this.$_.cloneDeep(this.value);
            const feature = this.form.features.find((x) => x.type === FeatureItems.CHAT);
            this.featureForm = feature || this.featureForm;
        },
    },
    watch: {
        value: {
            deep: true,
            handler() {
                this.init();
            },
        },
        form: {
            handler(newVal, oldVal) {
                if (!this.$_.isEqual(this.value, oldVal)) {
                    this.$emit("input", newVal);
                }
            },
            deep: true,
        },
        featureForm: {
            handler(v) {
                const response = { type: FeatureItems.CHAT, ...this.featureForm };
                const feature = this.form.features.findIndex((x) => x.type === FeatureItems.CHAT);
                if (feature < 0) {
                    this.form.features = [...this.form.features, response];
                } else {
                    this.form.features.splice(feature, 1, response);
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
$bg-color: #ec4b1d;

#plan-feature {
    margin-top: 20px;

    .feature {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .feature-title {
            font-weight: bold;
            font-size: 16px;
        }

        .feature-delete {
            background-color: $bg-color;
            padding: 5px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 2px;
            cursor: pointer;

            span {
                font-size: 14px;
                color: white;
            }
        }
    }
}
</style>
